const WEEKEND = ['0', '6'];

const isWeekend = testDay => WEEKEND.includes(testDay.format('d'));

export { isWeekend };
